<template>
  <el-row>
    <el-form label-width="130px">
      <el-row :gutter="50" v-if="form.type == 0">
        <h4>TLC方法</h4>
        <el-row>
          <el-col :span="6">
            <el-form-item label="TLC类型:">
              {{ form.tlc.label }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="TLC图片:">
            <img
              v-if="form.tlc.tlcPic != ''"
              :src="'data:image/png;base64,' + form.tlc.tlcPic"
              class="img-border img-size"
            />
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="展开剂信息:">
            <el-col :span="20">
              <el-row
                v-if="
                  form.tlc.solvents.length > 0 &&
                  form.tlc.solvents[0].Percent != ''
                "
              >
                <el-table :data="form.tlc.solvents" style="width: 100%">
                  <el-table-column
                    label="溶剂"
                    prop="Solvent"
                  ></el-table-column>
                  <el-table-column label="%" prop="Percent"></el-table-column>
                </el-table>
                <el-form-item label="备注:">
                  {{ form.tlc.remark }}
                </el-form-item>
              </el-row>
            </el-col>
          </el-form-item>
        </el-row>
      </el-row>
      <el-row :gutter="50" v-if="form.type == 1">
        <h4>HPLC方法</h4>
        <el-row>
          <el-col :span="8">
            <el-form-item label="名称:">
              {{ form.hplc.flashColumn.analysis_column }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流速:">
              {{ form.hplc.flashColumn.flow_rate }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="填料粒径:">
              {{ form.hplc.flashColumn.particle_diameter }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="内径:">
              {{ form.hplc.flashColumn.inner_diameter }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="长度:">
              {{ form.hplc.flashColumn.length }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="流动相A:">
              {{ form.hplc.flowA }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流动相B:">
              {{ form.hplc.flowB }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="HPLC图片:">
              <img
                v-if="form.hplc.hplcPic != ''"
                :src="'data:image/png;base64,' + form.hplc.hplcPic"
                class="img-border img-size"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
export default {
  name: "GetResCondition",
  data() {
    return {
      tlcTypeLabel: "",
      // flashColumnLabel: '',
      /**
       * 区分分析方法
       * */
      methodType: this.$store.state.sepaMethods.analysisMethodType,
      /**
       * TLC薄层板类别
       * */
      TLCType: this.$store.state.sepaMethods.TLCType,
      /**
       * 色谱柱填料类别
       * */
      columnFillerType: this.$store.state.sepaMethods.columnFillerType,
      FlowPhase: this.$store.state.sepaMethods.FlowPhase,
      FlowPhaseList: [],
    };
  },
  created() {
    this.tlcTypeLabel = this.TLCType[this.form.tlc.label]
      ? this.TLCType[this.form.tlc.label].label
      : "";
    if (this.form.hplc.flowPhase && this.form.hplc.flowPhase.length > 0) {
      this.form.hplc.flowPhase.forEach((item) => {
        this.FlowPhaseList.push(
          this.FlowPhase.find((val) => val.value == item).label
        );
      });
    }
    // this.flashColumnLabel = this.form.hplc.flashColumn?this.columnFillerType[this.form.hplc.flashColumn.type].label:''
  },
  props: {
    form: {},
  },
};
</script>

<style scoped></style>
